import { render, staticRenderFns } from "./VariablePayment.vue?vue&type=template&id=bbca2bea&scoped=true&"
import script from "./VariablePayment.vue?vue&type=script&lang=js&"
export * from "./VariablePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbca2bea",
  null
  
)

export default component.exports